import { Box, Typography } from '@mui/material';
import { NAVY } from '../../../styles/foundation/colors';
import { tertiaryTextSx } from './cellStyles';

// The order ID the merchant's channel/integrator (Unicommerce etc.) sent us. The order API
// returns it as client_order_id; filters query the stored field clientOrderId.
export const getClientOrderId = (order) => order?.client_order_id || order?.clientOrderId || '';

// Labelled line for the "Shipment Details" cell of the order list tabs.
export default function ClientOrderIdText({ row }) {
  const clientOrderId = getClientOrderId(row);
  if (!clientOrderId) return null;
  return (
    <Typography sx={{ ...tertiaryTextSx, wordBreak: 'break-all' }}>
      Client Order ID: <Box component="span" sx={{ color: NAVY }}>{clientOrderId}</Box>
    </Typography>
  );
}

// andfilter clause for the "Client Order ID" list filter (null when the field is empty).
export const clientOrderIdClause = (filters) => {
  const value = String(filters?.clientOrderId || '').trim();
  return value ? { field: 'clientOrderId', operator: 'eq', value } : null;
};
